const UNITS = ['B', 'KB', 'MB', 'GB', 'TB'];

/** 1536 -> "1,5 KB". Sempre binário (1024). */
export function formatBytes(value: number | null | undefined, digits = 1): string {
  if (value === null || value === undefined || isNaN(value)) return '';
  if (value < 1024) return `${value} B`;

  let size = value;
  let unit = 0;
  while (size >= 1024 && unit < UNITS.length - 1) {
    size /= 1024;
    unit++;
  }
  return `${size.toLocaleString(undefined, { maximumFractionDigits: digits })} ${UNITS[unit]}`;
}

export function megabytesToBytes(mb: number | null | undefined): number | null {
  if (mb === null || mb === undefined || isNaN(mb)) return null;
  return Math.round(mb * 1024 * 1024);
}

export function bytesToMegabytes(bytes: number | null | undefined): number | null {
  if (bytes === null || bytes === undefined || isNaN(bytes)) return null;
  return Math.round((bytes / 1024 / 1024) * 100) / 100;
}
